export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_trilha-sonora-lc/artifacts/mhckjbjg_CEFBCCCF-1E89-4CB8-94E9-0C7BA21990F0.png";

export const RECEPTION_STYLES = [
  "MPB", "Bossa Nova", "Pop Nacional", "Pop Internacional", "Rock Nacional",
  "Rock Internacional", "Cl\u00e1ssicos Rom\u00e2nticos", "Internacional Rom\u00e2ntico",
  "Internacional Animado", "Gospel", "M\u00fasica Crist\u00e3", "Instrumental", "Jazz",
  "Soul", "Pagode", "Samba", "Trilhas de Filmes", "Outros",
];

export const EXECUTION_OPTIONS = [
  { value: "inicio", label: "Desde o in\u00edcio" },
  { value: "introducao", label: "Introdu\u00e7\u00e3o" },
  { value: "refrao", label: "Refr\u00e3o" },
  { value: "completa", label: "M\u00fasica completa" },
  { value: "instrumental", label: "Instrumental" },
  { value: "especifico", label: "Momento espec\u00edfico" },
  { value: "livre", label: "Livre / A crit\u00e9rio da equipe musical" },
  { value: "outro", label: "Outro" },
];

export const EXECUTION_LABELS = EXECUTION_OPTIONS.reduce((a, o) => {
  a[o.value] = o.label;
  return a;
}, {});

export const SURPRISE_FOR = ["Noiva", "Noivo", "Pais", "Padrinhos", "Convidados", "Outro"];

export const AI_STYLES = [
  "Rom\u00e2ntico", "Cl\u00e1ssico", "Moderno", "Gospel/Crist\u00e3o", "MPB", "Rock", "Pop",
  "Internacional", "Cinematogr\u00e1fico", "Divertido", "Emocionante", "Elegante",
  "Diferente do tradicional",
];
export const AI_MOODS = [
  "Emocionar", "Surpreender", "Celebrar", "Criar expectativa", "Alegria",
  "Eleg\u00e2ncia", "Intimidade", "Energia",
];
export const AI_LANGUAGES = ["Portugu\u00eas", "Ingl\u00eas", "Internacional", "Instrumental", "Indiferente"];
export const AI_ERAS = ["Cl\u00e1ssicos", "Anos 80/90", "Anos 2000", "Atuais", "Indiferente"];

export const WIZARD_STEPS = ["Cortejo", "M\u00fasicas", "Forma\u00e7\u00e3o", "Recep\u00e7\u00e3o", "Revis\u00e3o", "Envio"];

export const FORMATION_TYPES = [
  "Solo", "Duo", "Trio", "Quarteto", "Quinteto", "Banda", "A definir com a LC",
];

export const INSTRUMENTS = [
  "Voz", "Violino", "Viola", "Violoncelo", "Teclado", "Piano", "Sax",
  "Viol\u00e3o", "Guitarra", "Baixo", "Bateria", "SPD / Percuss\u00e3o",
  "Flauta", "Harpa", "Trompete", "Caj\u00f3n",
];

export const STATUS_META = {
  aguardando: { label: "Aguardando preenchimento", dot: "#B7791F", tone: "warning" },
  em_preenchimento: { label: "Em preenchimento", dot: "#B7791F", tone: "warning" },
  enviado: { label: "Enviado pelo casal", dot: "#7A2E3A", tone: "marsala" },
  em_analise: { label: "Em an\u00e1lise pela LC", dot: "#2F5F8F", tone: "info" },
  ajustes: { label: "Ajustes necess\u00e1rios", dot: "#B42318", tone: "danger" },
  aprovado: { label: "Aprovado", dot: "#1F7A5A", tone: "success" },
  finalizado: { label: "Finalizado", dot: "#1F7A5A", tone: "success" },
};

export const ADMIN_STATUS_OPTIONS = Object.keys(STATUS_META);

export const EMOTIONAL_LINES = [
  "Cada escolha ajuda a contar a hist\u00f3ria de voc\u00eas.",
  "A trilha sonora desse momento come\u00e7a a ganhar forma.",
  "Falta pouco para finalizar o repert\u00f3rio do grande dia.",
];

export const SERVICES_META = {
  cerimonia: { label: "Cerim\u00f4nia", short: "CER", desc: "Planejamento do repert\u00f3rio musical da cerim\u00f4nia." },
  banda: { label: "Banda / Receptivo", short: "BANDA", desc: "Identidade musical da recep\u00e7\u00e3o ou apresenta\u00e7\u00e3o da banda." },
  astrolive: { label: "AstroLive", short: "ASTRO", desc: "Planejamento da experi\u00eancia e din\u00e2mica do show AstroLive." },
};

export const BANDA_STYLES = [
  "Pop Nacional", "Pop Internacional", "Rock Nacional", "Rock Internacional", "MPB",
  "Bossa Nova", "Samba", "Pagode", "Sertanejo", "Soul", "Funk / Disco", "Anos 70",
  "Anos 80", "Anos 90", "Anos 2000", "M\u00fasica Latina", "Internacional Rom\u00e2ntico",
  "Internacional Animado", "Gospel", "Outros",
];

export const BANDA_PERFIL = [
  "Mais elegante e ambiente",
  "Animado, mas sem muita intera\u00e7\u00e3o",
  "Bem animado e voltado para a pista",
  "Uma mistura entre momentos elegantes e animados",
  "Outro",
];

export const ASTRO_INTUITO = [
  "Quero colocar todo mundo para dan\u00e7ar e manter a pista intensa do in\u00edcio ao fim.",
  "Quero um show musical animado, mas sem exagerar nas intera\u00e7\u00f5es.",
  "Quero uma experi\u00eancia equilibrada entre m\u00fasica, performance e intera\u00e7\u00e3o.",
  "Quero algo mais musical e sofisticado.",
  "Outro.",
];

export const ASTRO_PERFIL = ["Secular", "Gospel", "Misto"];

export const ASTRO_INTERACAO = [
  "Muita intera\u00e7\u00e3o com a pista",
  "Intera\u00e7\u00e3o moderada",
  "Pouca intera\u00e7\u00e3o, priorizando a parte musical",
  "Deixamos a equipe decidir de acordo com o momento da festa",
];

export const ASTRO_PLAYLISTS = {
  Secular: "https://open.spotify.com/playlist/44lfHUoRUThfscQBCL4sUK?si=PpYiSPlxSfWr2n85i2HxVg&pi=066BoG2PT8qYq",
  Gospel: "https://open.spotify.com/playlist/3BdEaSDv5jPXcJgyGtXy2f?si=3STu7z0aSgOtKJj5sCCBGg&pi=lDL6SkEjTZehN",
};

export const SIM_NAO_NAOSEI = [
  { value: "sim", label: "Sim" },
  { value: "nao", label: "N\u00e3o" },
  { value: "nao_sei", label: "N\u00e3o sei / Confirmar com a LC" },
];
